import consultantDetail from '../../components/partners/consultant_detail'
import { createApp } from 'vue';
import BootstrapVueNext from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

if (document.getElementById('consultant-detail-page')) {
    const app = createApp({
        components:{
            consultantDetail
        }
    });
    app.use(BootstrapVueNext);
    app.mount('#consultant-detail-page');
}